import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { ParamsAndReturnTypes } from '@prisjakt/ui-translate/src/translate-func';
import { FontEmphasis } from '@prisjakt/ui/text';
import { CaptionText } from '@prisjakt/ui/text/variants';
import { ProductPriceType } from '../../../../../types';
import Icon from './components/stock-status-icon';
import PriceNotice from '../price-notice';
import * as S from './styles';

type OwnProps = {
  className?: string;
  priceType?: ProductPriceType | null;
};

const Label: React.FC = props => {
  return (
    <S.MediumUp>
      <CaptionText emphasis={FontEmphasis.MEDIUM}>{props.children}</CaptionText>
    </S.MediumUp>
  );
};

const PriceTypeNotice = ({ className, priceType }: OwnProps) => {
  const { t } = useContext(AppContext);
  const isUnusualPriceType =
    priceType &&
    priceType !== ProductPriceType.NORMAL &&
    priceType !== ProductPriceType.USED_PRODUCT &&
    priceType !== ProductPriceType.NOT_IN_MINT_CONDITION;

  if (!isUnusualPriceType) {
    return null;
  }

  return (
    <S.BadgeWrapper className={className}>
      <S.Badge>
        <Icon
          icon={
            <PriceNotice
              type={priceType as NonNullable<ProductPriceType>}
              hideText
            />
          }
          tooltipText={t(
            'product',
            `price-notice.${priceType}` as keyof ParamsAndReturnTypes['product']
          )}
          showTooltip
        />
        <Label>
          {t(
            'product',
            `price-notice.${priceType}` as keyof ParamsAndReturnTypes['product']
          )}
        </Label>
      </S.Badge>
    </S.BadgeWrapper>
  );
};

export default PriceTypeNotice;
